<template>
  <v-navigation-drawer v-model="open" fixed right temporary width="680" class="audit-trail-panel">
    <v-toolbar flat class="audit-trail-panel__bar">
      <v-toolbar-title class="text-h6">{{ $t('audit-trail.title') }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon :aria-label="$t('close')" @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider />
    <div v-if="open" class="pa-4">
      <div v-if="fields.length || actionPrefixes.length" class="d-flex align-center mb-2">
        <span class="text-caption text--secondary">{{ $t(fields.length ? 'audit-trail.this-form' : 'audit-trail.these-actions') }}</span>
        <v-btn x-small text color="primary" class="ml-2" @click="fields = []; actionPrefixes = []">{{ $t('audit-trail.see-all') }}</v-btn>
      </div>
      <audit-trail-list compact :entity-type="filters.entityType" :entity-id="filters.entityId" :module="filters.module" :organization-id="filters.organizationId" :fields="fields" :action-prefixes="actionPrefixes" />
    </div>
  </v-navigation-drawer>
</template>

<script>
import { EventBus } from '@includes/EventBus'
import AuditTrailList from '@elements/AuditTrailList.vue'

/**
 * Le panneau d'historique, un seul pour toute l'application, monté dans la mise en page : il ne dépend donc pas de
 * l'écran qui l'ouvre (un panneau dans un panneau serait enfermé par celui qui le contient). `AuditTrailButton` l'ouvre.
 */
export default {
  name: 'AuditTrailPanel',
  components: { AuditTrailList },

  data() {
    return { open: false, filters: {}, fields: [], actionPrefixes: [], subscriptions: [] }
  },

  watch: {
    open(value) {
      if (!value) {
        EventBus.$emit('audit-trail:closed')
      }
    },
    $route() {
      this.open = false
    },
  },

  created() {
    this.subscriptions = [
      EventBus.$on('audit-trail:open', ({ fields, actionPrefixes, ...filters }) => {
        this.filters = filters
        this.fields = fields || []
        this.actionPrefixes = actionPrefixes || []
        this.open = true
      }),
      EventBus.$on('audit-trail:close', () => { this.open = false }),
    ]
  },

  beforeDestroy() {
    this.subscriptions.forEach(subscription => EventBus.$off(null, subscription))
  },
}
</script>

<style scoped>
/* Au-dessus d'un panneau latéral qui l'aurait ouvert. */
.audit-trail-panel {
  z-index: 210;
}

.audit-trail-panel__bar {
  flex: 0 0 auto;
}
</style>
